import { createIcon } from '../icon'
import ArrowIconBreadcrumb from '../svg/ArrowIconBreadcrumb'

export const ArrowIconBreadcrumbnDefault = createIcon(ArrowIconBreadcrumb)
